'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: ', 'px;\n  min-width: ', 'px;\n  max-width: ', 'px;\n  height: ', 'px;\n  display: block;\n  background: ', ';\n  color: ', ';\n  border-radius: 3px;\n  border: none;\n  margin: 0px ', 'px;\n  padding: 0px;\n  opacity: ', ';\n  cursor: ', ';\n  font-family: inherit;\n  font-size: ', 'px;\n  font-weight: 400;\n'], ['\n  width: ', 'px;\n  min-width: ', 'px;\n  max-width: ', 'px;\n  height: ', 'px;\n  display: block;\n  background: ', ';\n  color: ', ';\n  border-radius: 3px;\n  border: none;\n  margin: 0px ', 'px;\n  padding: 0px;\n  opacity: ', ';\n  cursor: ', ';\n  font-family: inherit;\n  font-size: ', 'px;\n  font-weight: 400;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Styles


var fontColor = function fontColor(_ref) {
  var selected = _ref.selected,
      icon = _ref.icon;
  if (icon) return _colors.darkGrey;
  return selected ? _colors.white : _colors.black;
};

var bgColor = function bgColor(_ref2) {
  var selected = _ref2.selected,
      icon = _ref2.icon;
  if (icon) return _colors.grey;
  return selected ? _colors.red : 'none';
};

var Container = _styledComponents2.default.button(_templateObject, function (_ref3) {
  var small = _ref3.small;
  return small ? 14 : 20;
}, function (_ref4) {
  var small = _ref4.small;
  return small ? 14 : 20;
}, function (_ref5) {
  var small = _ref5.small;
  return small ? 14 : 20;
}, function (_ref6) {
  var small = _ref6.small;
  return small ? 14 : 20;
}, bgColor, fontColor, function (_ref7) {
  var small = _ref7.small;
  return small ? 2 : 5;
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled ? 0.5 : 1;
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref10) {
  var small = _ref10.small;
  return small ? 10 : 12;
});

var PaginationButton = function PaginationButton(_ref11) {
  var icon = _ref11.icon,
      page = _ref11.page,
      onClick = _ref11.onClick,
      selected = _ref11.selected,
      small = _ref11.small,
      disabled = _ref11.disabled;
  return _react2.default.createElement(Container, {
    small: small,
    icon: icon,
    selected: selected,
    disabled: disabled,
    onClick: onClick
  }, icon ? _react2.default.createElement(_Icon2.default, {
    icon: icon
  }) : page);
};

PaginationButton.propTypes = {
  icon: _propTypes2.default.string,
  page: _propTypes2.default.number,
  onClick: _propTypes2.default.func.isRequired,
  selected: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};
PaginationButton.defaultProps = {
  icon: null,
  page: 0,
  selected: false,
  small: false,
  disabled: false
};
exports.default = PaginationButton;